import { render, staticRenderFns } from "./LotteryDraw.vue?vue&type=template&id=5adab646&scoped=true"
import script from "./LotteryDraw.vue?vue&type=script&lang=js"
export * from "./LotteryDraw.vue?vue&type=script&lang=js"
import style0 from "./LotteryDraw.vue?vue&type=style&index=0&id=5adab646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adab646",
  null
  
)

export default component.exports